var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgErrorWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.77169 3.68101L2.11021 14.8018C1.97286 15.0397 1.90019 15.3093 1.89942 15.584C1.89865 15.8587 1.96981 16.1287 2.10582 16.3673C2.24183 16.606 2.43795 16.8048 2.67467 16.9441C2.91138 17.0834 3.18045 17.1582 3.45509 17.1613H16.7781C17.0527 17.1582 17.3218 17.0834 17.5585 16.9441C17.7952 16.8048 17.9913 16.606 18.1273 16.3673C18.2633 16.1287 18.3345 15.8587 18.3337 15.584C18.3329 15.3093 18.2603 15.0397 18.1229 14.8018L11.4614 3.68101C11.3212 3.44987 11.1238 3.25876 10.8883 3.12613C10.6527 2.9935 10.3869 2.92383 10.1166 2.92383C9.84623 2.92383 9.58045 2.9935 9.34488 3.12613C9.10931 3.25876 8.91189 3.44987 8.77169 3.68101V3.68101Z",
    stroke: "#FFAA00",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1162 7.72314V10.8691",
    stroke: "#FFAA00",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1162 14.0151H10.1241",
    stroke: "#FFAA00",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorWarning);
export default __webpack_public_path__ + "static/media/errorWarning.9f594627f36b2efb72e467da9d00fee4.svg";
export { ForwardRef as ReactComponent };